import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M49.6104 84.7015C50.7982 83.7615 58.4788 77.7984 62.8073 62.3348C66.6023 49.1958 67.7398 27.0211 60.3612 16.0854C57.4428 11.6951 53.4905 8.09568 48.8548 5.60629C44.2191 3.1169 39.0432 1.81445 33.7861 1.81445C28.529 1.81445 23.3531 3.1169 18.7174 5.60629C14.0817 8.09568 10.1295 11.6951 7.21107 16.0854C-0.167533 27.0211 0.979982 49.2261 4.77498 62.3348C9.09343 77.7984 16.7741 83.7615 17.9619 84.7015C20.0657 86.3691 26.5384 87.8144 33.8062 87.8144C41.0741 87.8144 47.5065 86.3691 49.6104 84.7015Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
